// DiscountForm.js
import React, { useEffect, useState } from "react";
import * as helpers from "../../utils/utils.js";
import "./discountForm.css";
import { check } from "prettier";

const DiscountForm = ({
  addManualDiscount

}) => {
  const [discountCode, setDiscountCode] = useState("");
  const [validationMessage, setValidationMessage] = useState(null);

  async function handleFormSubmit(e) {
    e.preventDefault();
    // check discount codes with request

    const { applied, message} = addManualDiscount(discountCode);

    if (!applied) {
      setValidationMessage(message);
    }
    setDiscountCode("");
  }

  function handleInputChange(event) {
    setDiscountCode(event.target.value);
  }

  return (
    <div className="discount-container">
      {/* <div className='instructions'>Enter Discount or Promo Code Below.</div> */}
      <form onSubmit={(e) => handleFormSubmit(e)}>
        <div className="discount-form">
          <div className="discount-group">
            <input
              placeholder="Enter Discount Code"
              type="text"
              name="discountCode"
              value={discountCode}
              onChange={handleInputChange}
              className="form-control"
            />

            {validationMessage && (
              <div className="invalid">{validationMessage}</div>
            )}
          </div>
          <button className="btn discount-sbmt-btn" type="submit">
            Apply
          </button>
        </div>
      </form>
    </div>
  );
};

export default DiscountForm;
